// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
ion-title {
  text-align: center;
}

ion-row {
  align-items: center;
}

button {
  height: 2.3rem;
  width: 2.3rem;
  border-radius: 100%;
  margin-right: 0.5rem;
}

ion-fab-button {
  width: 3rem;
  height: 3rem;
  color: rgb(0, 170, 0);
}

h2 {
  font-weight: bold;
}

.modalContent {
  min-height: 100%;
}

.clientBox {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  flex: 0 0 auto;
  margin-right: 0.5rem;
  height: 3rem;
  width: 3rem;
  border-radius: 80px;
  cursor: pointer;
  color: white;
}

.box {
  margin-left: 5%;
  width: 100%;
}

.backgroundTab {
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  height: 100%;
  border-radius: 30px;
  background-color: #ffffff;
  transition: transform 0.3s ease;
  z-index: -1;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}

.tab {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 5rem;
  border-radius: 30px;
  color: #333; /* Couleur du texte par défaut (bleu) */
  transition: color 0.3s ease; /* Ajoutez une transition pour la couleur du texte */
}

.selected {
  color: #007bff;
  transition: color 0.3s ease;
}

.position {
  transform: translateX(100%); /* Déplacez la backgroundTab à droite de 100% de sa largeur */
}

ion-content {
  --ion-background-color: rgb(247, 247, 247);
}

ion-searchbar {
  --box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  --border-radius: 15px;
  --background: white;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Coach/client/list-user/list-user.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,kBAAA;AAEJ;;AACA;EACI,mBAAA;AAEJ;;AACA;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;AAEJ;;AACA;EACI,WAAA;EACA,YAAA;EACA,qBAAA;AAEJ;;AACA;EACI,iBAAA;AAEJ;;AACA;EACI,gBAAA;AAEJ;;AACA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AAEJ;;AACE;EACE,eAAA;EACA,WAAA;AAEJ;;AACE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,+BAAA;EACA,WAAA;EACA,iDAAA;AAEJ;;AACE;EACE,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA,EAAA,uCAAA;EACA,2BAAA,EAAA,oDAAA;AAEJ;;AACE;EACE,cAAA;EACA,2BAAA;AAEJ;;AACE;EACE,2BAAA,EAAA,6DAAA;AAEJ;;AACE;EACE,0CAAA;AAEJ;;AACE;EACE,mDAAA;EACA,qBAAA;EACA,mBAAA;AAEJ","sourcesContent":["ion-title{\r\n    text-align: center;\r\n}\r\n\r\nion-row{\r\n    align-items: center;\r\n}\r\n\r\nbutton{\r\n    height: 2.3rem;\r\n    width: 2.3rem;\r\n    border-radius: 100%; \r\n    margin-right: 0.5rem;\r\n}\r\n\r\nion-fab-button{\r\n    width: 3rem;\r\n    height: 3rem;\r\n    color: rgb(0, 170, 0);\r\n}\r\n\r\nh2{\r\n    font-weight: bold;\r\n}\r\n\r\n.modalContent{\r\n    min-height: 100%;\r\n}\r\n\r\n.clientBox {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 0.5rem;\r\n    flex: 0 0 auto;\r\n    margin-right: 0.5rem;\r\n    height: 3rem;\r\n    width: 3rem;\r\n    border-radius: 80px;\r\n    cursor: pointer;\r\n    color: white;\r\n  }\r\n\r\n  .box{\r\n    margin-left: 5%;\r\n    width: 100%;\r\n  }\r\n\r\n  .backgroundTab {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 50%; \r\n    height: 100%;\r\n    border-radius: 30px;\r\n    background-color: #ffffff; \r\n    transition: transform 0.3s ease; \r\n    z-index: -1; \r\n    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\r\n  }\r\n  \r\n  .tab {\r\n    flex: 1;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    cursor: pointer;\r\n    width: 5rem;\r\n    border-radius: 30px;\r\n    color: #333; /* Couleur du texte par défaut (bleu) */\r\n    transition: color 0.3s ease; /* Ajoutez une transition pour la couleur du texte */\r\n  }\r\n  \r\n  .selected {\r\n    color: #007bff;\r\n    transition: color 0.3s ease;\r\n  }\r\n  \r\n  .position {\r\n    transform: translateX(100%); /* Déplacez la backgroundTab à droite de 100% de sa largeur */\r\n  }\r\n\r\n  ion-content{\r\n    --ion-background-color : rgb(247, 247, 247);   \r\n  }\r\n\r\n  ion-searchbar{\r\n    --box-shadow:  rgba(149, 157, 165, 0.2) 0px 8px 24px;\r\n    --border-radius : 15px;\r\n    --background: white;\r\n    \r\n  }\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
